/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2018, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'jquery',
	'../../../lib/@waca/core-client/js/core-client/ui/core/View',
	'../../../lib/@waca/core-client/js/core-client/utils/ContentFormatter',
	'./internal/JumpToViewComponents',
	'react-dom',
	'react'
], function ($, View, ContentFormatter, JumpToViewComponents,ReactDOM,React) {

	class JumpToViewReact extends View {

		init(...args){
			this.events = {
				'primaryaction .drillToTarget': '_drillToTarget',
				'primaryaction .manageDrillThrough': '_manageDrillThrough',
				'primaryaction .addNewTarget': '_addNewTarget'
			};
			super.init(...args);
			const options = args[0] || {};
			this.content = options.content;
			this.dashboard = options.dashboardApi;
			this.sourceId = options.sourceId;
			if (options.jumpToTargets) {
				this.jumpToTargets = options.jumpToTargets(this.content, this.sourceId, options.selections);
			}
			this.isDataPointSelection = options.isDataPointSelection || false;
			this.scopedPageContext = options.scopedPageContext;
			this.reactDomNode = this.$el[0];
		}

		_hideToolbar(){
			const toolbar = this.getToolbar();
			if(toolbar){
				this.remove();
				toolbar.hide();
			}
		}

		_drillToTarget(event) {
			this._hideToolbar();
			const id = event.currentTarget.getAttribute('data-id');
			const target = this.jumpToTargets.targetsMap[id];
			if (target) {
				target.jumpTo();
			}
		}

		_manageDrillThrough() {
			this._hideToolbar();
			return this.dashboard.getDashboardSvc('DrillThroughService')
				.then( (drillThroughService) => {
					return drillThroughService.getDrillThroughModelApi()
						.then((dtModelApi) => {
							var controller = drillThroughService.getDrillThroughController();
							var dlg = controller.manageDrillDefinition({
								content: this.content,
								dashboard: this.dashboard,
								drillThroughModelApi: dtModelApi
							});
							dlg.render();
						});
				});
		}

		_addNewTarget() {
			this._hideToolbar();
			return this.dashboard.getDashboardSvc('DrillThroughService')
				.then( (drillThroughService) => {
					const controller = drillThroughService.getDrillThroughController();
					controller.createDrillDefinition(this.content);
				});
		}


		/**
		 * Renders the dialog
		 */
		render() {
			ReactDOM.render(
				<JumpToViewComponents
					content ={this.content}
					dashboard = {this.dashboard}
					sourceId = {this.sourceId}
					jumpToTargets = {this.jumpToTargets}
					isDataPointSelection = {this.isDataPointSelection}
					scopedPageContext = {this.scopedPageContext}
					remove={this.remove.bind(this)}
					toolbar={this.getToolbar.bind(this)}
				/>,
				this.reactDomNode
			);
		}

		remove() {
			if (this.reactDomNode) {
				ReactDOM.unmountComponentAtNode(this.reactDomNode);
			}
			if (this.$el) {
				this.$el.remove();
				this.$el = null;
			}
			super.remove();
		}

		getToolbar(){
			return this.toolbar;
		}

		preload(){
			return Promise.resolve();
		}

		renderCallBack(toolbar){
			this.toolbar = toolbar;
		}

		notifyRenderComplete() {
			//Set focus to the first item
			this.$el.find('.visJumpToView-item:first').focus();
		}


	}

	return JumpToViewReact;
});
